import request from '../config/axiosConfig';
import {
  GET_DATA_NOTIFICATION_STATISTICS,
  GET_DIMENSIONS_NOTIFICATION,
  GET_GRAPHICAL_NOTIFICATION_STATISTICS,
  GET_LICH_VIET_CAMPAIGNS,
  GET_METRICS_NOTIFICATION,
  GET_NOTIFICATION_AUDIENCES,
  GET_NOTIFICATION_LABELS,
  GET_NOTIFICATION_TYPES,
  GET_NOTIFICATIONS,
} from '../constants/apiEndPoint';

export const getDataStatisticNotificationRequest = async (data) => {
  const result = await request({
    url: GET_DATA_NOTIFICATION_STATISTICS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const getGraphicalStatisticNotificationRequest = async (data) => {
  const result = await request({
    url: GET_GRAPHICAL_NOTIFICATION_STATISTICS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const getListDimensionsNotificationRequest = async (data) => {
  const result = await request({
    url: GET_DIMENSIONS_NOTIFICATION,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListMetricsNotificationRequest = async (data) => {
  const result = await request({
    url: GET_METRICS_NOTIFICATION,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListNotificationTypesRequest = async (data) => {
  const result = await request({
    url: GET_NOTIFICATION_TYPES,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListNotificationAudidencesRequest = async (data) => {
  const result = await request({
    url: GET_NOTIFICATION_AUDIENCES,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListAllNotificationsRequest = async (data) => {
  const result = await request({
    url: GET_NOTIFICATIONS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListAllCampaignsLichVietRequest = async (data) => {
  const result = await request({
    url: GET_LICH_VIET_CAMPAIGNS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const getListNotificationLabelsRequest = async (data) => {
  const result = await request({
    url: GET_NOTIFICATION_LABELS,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};
